<ng-container *ngIf="isMobile">
  <div class="navigation-menu">
    <div *ngFor="let item of navigationItems" data-cy="mobile-additional-links">
      <cm-navigation-item
        [showFavorite]="showFavoriteOption"
        [navigationItem]="item"
        [isProfile]="displayMode === MenuDisplayMode.PROFILE"
      ></cm-navigation-item>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isMobile">
  <nav class="navigation-menu" [ngClass]="{ ' shrinked': isShrinked }">
    <!-- favorite items  when not Shrinked-->
    <div *ngIf="navigationService.favoriteMenuItems.length && !isShrinked" class="navigation-menu__favorite-section">
      <ng-container *ngFor="let item of navigationService.favoriteMenuItems">
        <cm-menu-navigation-item
          data-cy="favorite-nav-item"
          [navigationItem]="item"
          [sectionChildFavorite]="true"
          [isChild]="false"
        ></cm-menu-navigation-item>
      </ng-container>
    </div>
    <!-- favorite items when Shrinked-->
    <div *ngIf="navigationService.favoriteMenuItems.length && isShrinked" class="navigation-menu__favorite-section">
      <div>
        <cm-menu-navigation-item
          [favoriteIcon]="true"
          (click)="toggleSubMenu('favorites')"
          (mouseenter)="toggleSubMenu(section)"
        ></cm-menu-navigation-item>
        <cm-navigation-section-menu
          *ngIf="sectionSubMenu === 'favorites'"
          [navigationItems]="navigationService.favoriteMenuItems"
          (clickEvent)="trackNavigateEvent($event)"
          (clickOutEvent)="toggleSubMenu($event)"
        >
        </cm-navigation-section-menu>
      </div>
    </div>
    <!-- fixed items -->
    <div
      *ngIf="navigationService.menuNavFixedItems.length"
      class="navigation-menu__top-section"
      [ngClass]="{ ' shrinked': isShrinked }"
    >
      <ng-container *ngFor="let item of navigationService.menuNavFixedItems">
        <cm-menu-navigation-item
          [disableFavorite]="true"
          [navigationItem]="item"
          [isChild]="false"
        ></cm-menu-navigation-item>
      </ng-container>
    </div>

    <!-- sections items when not Shrinked-->
    <mat-accordion
      class="navigation-sections"
      *ngIf="navigationService.navigationSections.length && !isShrinked"
      [multi]="true"
    >
      <!-- sections -->
      <ng-container
        *ngFor="
          let section of navigationService.navigationSections;
          trackBy: navigationService?.sectionItemIdentifyer
        "
      >
        <mat-expansion-panel
          [hideToggle]="true"
          (opened)="onMenuExpanded(section.name)"
          (closed)="onMenuCollapsed(section.name)"
          #exPanel
          *visibility="{ navItems: section.items || null }"
        >
          <!-- section header -->
          <mat-expansion-panel-header>
            <div class="navigation-sections__left-icon">
              <mat-icon
                class="navigation-sections_icon"
                [attr.data-cy]="section.dataCy +'-icon'"
                [ngClass]="{ ' navigation-sections_icon--active': section.type === this.selectedSection,
              '  navigation-sections_icon--small-icon': section.type === 'item_and_cribs'
            }"
                >{{ section.iconClass }}</mat-icon
              >
            </div>
            <mat-panel-title [attr.data-cy]="section.dataCy" class="navigation-sections_title">
              {{ navigationService.navNameTranslation(section.name) }}</mat-panel-title>
            <mat-icon
              [attr.data-cy]="section.dataCy + '-arrow-up'"
              class="navigation-sections_arrow"
              *ngIf="exPanel.expanded"
              >arrow_drop_up</mat-icon
            >
            <mat-icon
              [attr.data-cy]="section.dataCy + '-arrow-down'"
              class="navigation-sections_arrow"
              *ngIf="!exPanel.expanded"
              >arrow_drop_down</mat-icon
            >
          </mat-expansion-panel-header>
          <!-- section items -->
          <ng-container
            *ngFor="
              let item of section.items;
              trackBy: navigationService?.sectionItemIdentifyer
            "
          >
            <cm-menu-navigation-item [navigationItem]="item" [sectionChild]="true"></cm-menu-navigation-item>
          </ng-container>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>

    <!-- sections items when Shrinked  -->
    <div
      *ngIf="navigationService.navigationSections.length && isShrinked"
      class="navigation-menu__top-section shrinked"
    >
      <ng-container *ngFor="let section of navigationService.navigationSections">
        <div>
          <cm-menu-navigation-item
            (click)="toggleSubMenu(section)"
            (mouseenter)="toggleSubMenu(section)"
            [navigationSection]="section"
            [selectedSectionValue]="selectedSection"
          >
          </cm-menu-navigation-item>
          <cm-navigation-section-menu
            *ngIf="section === sectionSubMenu"
            [navigationItems]="section.items"
            (clickEvent)="trackNavigateEvent($event)"
            (clickOutEvent)="toggleSubMenu($event)"
          >
          </cm-navigation-section-menu>
        </div>
      </ng-container>
    </div>
  </nav>
</ng-container>

<ng-template #loadingSpinner>
  <mat-spinner></mat-spinner>
</ng-template>
